import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'MyAccountModalContainer'

    static propTypes = {
      changePassword: PropTypes.func.isRequired,
      close: PropTypes.func.isRequired,
      hasError: PropTypes.bool.isRequired,
      isPending: PropTypes.bool.isRequired,
      user: PropTypes.object.isRequired,
    }

    state = {
      form: {
        passwordNew1: '',
        passwordNew2: '',
        passwordOld: '',
      },
    }

    handleInputChange = (e, { name, value }) => {
      this.setState({ form: { ...this.state.form, [name]: value } })
    }

    handleSubmit = e => {
      const { changePassword, user } = this.props
      const { passwordNew1, passwordNew2, passwordOld } = this.state.form

      e.preventDefault()

      if (passwordNew1 === passwordNew2) {
        changePassword(passwordOld, passwordNew1, user.id)
      } else {
        changePassword(null, null)
      }
    }

    render() {
      return (
        <WrappedComponent
          close={this.props.close}
          form={this.state.form}
          handleInputChange={this.handleInputChange}
          handleSubmit={this.handleSubmit}
          hasError={this.props.hasError}
          isPending={this.props.isPending}
          user={this.props.user}
        />
      )
    }
  }

  return Container
}
